import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { DoeState } from './state';

export const getters: GetterTree<DoeState, RootState> = {
    getDoeTableHeader(state) {
        return state.tableHeader;
    },
    getItems(state) {
        return state.does;
    },
    isLoading(state) {
        return state.isDoeLoading;
    },
    isPdfLoading(state) {
        return state.isPdfLoading;
    },
    getNbItems(state) {
        return state.count;
    },
    getPage(state) {
        return state.page;
    },
    getNbOfPages(state) {
        return state.nbOfPages;
    },
    getSort(state) {
        return state.sort;
    }
};
